/* eslint-disable max-classes-per-file */
import { ColumnType } from './column.plainObject';

export class ParameterPlainObject {
    public name: string;
    public defaultValue: string;
    public dataType: ColumnType;
}

export class ParameterValuePlainObject {
    public name: string;
    public value: string;
}
